/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Feature_Api_AccessInputs */

const en_landing_pricing_feature_api_access = /** @type {(inputs: Landing_Pricing_Feature_Api_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API access`)
};

const zh_landing_pricing_feature_api_access = /** @type {(inputs: Landing_Pricing_Feature_Api_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API 访问`)
};

/**
* | output |
* | --- |
* | "API access" |
*
* @param {Landing_Pricing_Feature_Api_AccessInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_feature_api_access = /** @type {((inputs?: Landing_Pricing_Feature_Api_AccessInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Feature_Api_AccessInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_feature_api_access(inputs)
	return zh_landing_pricing_feature_api_access(inputs)
});
export { landing_pricing_feature_api_access as "landing.pricing.feature_api_access" }